import React from 'react';
import { Icons } from '@/assets';

const MemberActionMenu = ({
  menuRef,
  menuPosition,
  onEdit,
  onDelete,
  onPaymentHistory,
}) => {
  return (
    <div
      ref={menuRef}
      className="fixed bg-white p-1 border border-solid rounded-lg shadow-lg z-50 min-w-150 border-border-tertiary"
      style={{
        minWidth: '120px',
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
      }}>
      <div
        onClick={onEdit}
        className="flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-50 rounded-sm"
        style={{
          fontSize: '12px',
          color: '#717784',
          fontFamily: 'Averta PE, sans-serif',
        }}>
        <img src={Icons.pen} alt="Edit" className="w-4 h-4" />
        <span>Edit</span>
      </div>
      <div
        className="h-px bg-gray-200 my-0"
        style={{ backgroundColor: '#E1E4EA' }}
      />
      <div
        onClick={onDelete}
        className="flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-50 rounded-sm"
        style={{
          fontSize: '12px',
          color: '#717784',
          fontFamily: 'Averta PE, sans-serif',
        }}>
        <img src={Icons.deleteIcon} alt="Delete" className="w-4 h-4" />
        <span>Delete</span>
      </div>
      <div
        className="h-px bg-gray-200 my-0"
        style={{ backgroundColor: '#E1E4EA' }}
      />
      <div
        onClick={(e) => {
          e.stopPropagation();
          onPaymentHistory();
        }}
        className="flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-50 rounded-sm"
        style={{
          fontSize: '12px',
          color: '#717784',
          fontFamily: 'Averta PE, sans-serif',
        }}>
        <img
          src={Icons.historyList}
          alt="Payment history"
          className="w-4 h-4"
        />
        <span>Payment history</span>
      </div>
    </div>
  );
};

export default MemberActionMenu;
